import { Container } from "react-bootstrap";
import bindeep from "../../Assets/Projects/issue2.webp";
import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FullReader from "../Projects/comics/FullReader";

function Verify() {
  const navigate = useNavigate();
  const [showReader, setShowReader] = useState(false);
  const [pages, setPages] = useState([]);
  const [allPageNumbers, setAllPageNumbers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);

  const BATCH_SIZE = 10;

  useEffect(() => {
    const authenticateAndLoad = async () => {
      try {
        const res = await fetch("https://api.pall-o.com/protected", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Unauthorized: ${text}`);
        }

        const pageListRes = await fetch("https://api.pall-o.com/secure-content/page-list", {
          method: "GET",
          credentials: "include",
        });

        const pageList = await pageListRes.json();
        const sorted = pageList.map(Number).sort((a, b) => a - b);
        setAllPageNumbers(sorted);
        await loadNextBatch(sorted, 0);
      } catch (err) {
        console.error("Access check failed:", err);
        navigate("/");
      }
    };

    authenticateAndLoad();
  }, [navigate]);

  const loadNextBatch = useCallback(async (sourcePages = allPageNumbers, startIndex = currentIndex) => {
    if (loading || startIndex >= sourcePages.length) return;

    setLoading(true);

    try {
      const nextPages = sourcePages.slice(startIndex, startIndex + BATCH_SIZE);

      const loaded = await Promise.all(
        nextPages.map(async (pageNum) => {
          const res = await fetch(`https://api.pall-o.com/secure-content/comic-pages/${pageNum}.jpg`, {
            method: "GET",
            credentials: "include",
          });
          if (!res.ok) throw new Error(`Failed to load page ${pageNum}`);
          const blob = await res.blob();
          return URL.createObjectURL(blob);
        })
      );

      setPages((prev) => [...prev, ...loaded]);
      setCurrentIndex((prev) => prev + BATCH_SIZE);
    } catch (err) {
      console.error("Failed to load batch:", err);
    } finally {
      setLoading(false);
    }
  }, [allPageNumbers, currentIndex, loading]);

  const handleScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 200 && !loading) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        loadNextBatch();
      }, 250);
    }
  }, [loadNextBatch, loading]);

  return (
    <Container fluid className="project-section">
      <Container>
        {!showReader ? (
          <img
            className="ComicCover"
            src={bindeep}
            alt="Comic cover"
            onClick={() => setShowReader(true)}
          />
        ) : loading && pages.length === 0 ? (
          <p>Loading comic pages...</p>
        ) : (
          <FullReader pages={pages} onScroll={handleScroll} />
        )}
      </Container>
    </Container>
  );
}

export default Verify;
